import React from "react"
import { useSelector } from "react-redux"
import SelectFixedOptions from "./SelectFixedOptions"

const DISPLAY_CENTERS = {
  owner: { displayBrands: false, displayDelegations: false },
  admin: { displayBrands: false, displayDelegations: false },
  brandManager: { displayBrands: true, displayDelegations: false },
  delegationManager: { displayBrands: true, displayDelegations: true },
  operator: { displayBrands: true, displayDelegations: true },
  comunityManager: { displayBrands: false, displayDelegations: false },
  default: { displayBrands: true, displayDelegations: true },
}

const getObjectValues = function (objValues) {
  return objValues.map((item) => ({
    value: item._id,
    label: item.name,
    data: item,
  }))
}

const reduceArray = function (list, aObj) {
  try {
    const reduced = list
      .reduce((preV, next) => {
        const item = aObj?.find(elem => elem._id === next._id)

        preV.push({
          value: item ? item._id : next._id,
          label: item ? item.name : next.name,
          data: item ? item : next || {},
          isFixed: !item,
        })
        return preV
      }, [])
      .sort((a, b) => (a.isFixed === b.isFixed ? 0 : a.isFixed ? -1 : 1))
    return reduced
  } catch (error) {
    console.log("error: ", error)
    return []
  }
}

/**
 * Select brand and delegations with fixed options in select
 * @param {object} props
 * @param {string} props.operatorRole
 * @param {[{_id: string, name: string}]} props.currentBrands
 * @param {[{_id: string, name: string, brand: string}]} props.currentDelegations
 * @param {function} props.onChange
 * @param {{brands: string, delegations: string}} [props.errors]
 * @param {string} [props.brandClassName]
 * @param {string} [props.delegationClassName]
 * @param {boolean} [props.isMultiline]
 * @param {boolean} [props.isDisabled]
 */
const SelectBrandDelegations = function (props) {
  const {
    operatorRole,
    brandClassName = "",
    isMultiline = false,
    isDisabled = false,
    errors = {},
    delegationClassName,
    currentBrands = [],
    currentDelegations = [],
    onChange
  } = props

  const { brands, delegations } = useSelector(({ centers }) => centers)

  const brandOptions = getObjectValues(brands || [])
  const selectedBrands = !brands ? [] : reduceArray(currentBrands, brands)

  const delegationsOptions =
    selectedBrands.length > 0
      ? getObjectValues(delegations || []).filter((elem) =>
        selectedBrands.find((b) => b.value === elem.data.brand)
      )
      : []
  const selectedDelegations = !delegations ? [] : reduceArray(currentDelegations, delegations)

  const { displayBrands, displayDelegations } =
    DISPLAY_CENTERS[operatorRole] || DISPLAY_CENTERS.default

  const renderBrands = () => {
    if (displayBrands) {
      return (
        <SelectFixedOptions
          label='dashboard_brands'
          isMultiline={isMultiline}
          className={brandClassName}
          isDisabled={isDisabled}
          options={brandOptions}
          values={isMultiline ? selectedBrands : selectedBrands[0] || ""}
          error={errors.brands}
          type="brands"
          onChange={onChange}
        />
      )
    }
  }

  const renderDelegations = () => {
    if (displayDelegations) {
      return (
        <SelectFixedOptions
          label='dashboard_delegations'
          isMultiline={isMultiline}
          className={delegationClassName || ""}
          isDisabled={isDisabled}
          options={delegationsOptions}
          values={
            isMultiline ? selectedDelegations : selectedDelegations[0] || ""
          }
          error={errors.delegations}
          type="delegations"
          onChange={onChange}
        />
      )
    }
  }

  return (
    <>
      {renderBrands()}
      {renderDelegations()}
    </>
  )
}

export default SelectBrandDelegations
